import { render, staticRenderFns } from "./NewEditBasic.vue?vue&type=template&id=2dcb6629&scoped=true&"
import script from "../../models/usen-manage/new-edit-basic.ts?vue&type=script&lang=ts&"
export * from "../../models/usen-manage/new-edit-basic.ts?vue&type=script&lang=ts&"
import style0 from "./NewEditBasic.vue?vue&type=style&index=0&id=2dcb6629&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb6629",
  null
  
)

export default component.exports